import CreateTabs from "common/components/createTabs";
import { JobOpeningIcon } from "services/Recruit/assets/svg/JobOpening";
import { useEffect, useState } from "react";
import { Box, Button, Input, Textarea } from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FormLabel,
  Grid,
  GridItem,
  InputGroup,
  InputRightElement,
  Select as ChakraSelect,
  Text,
} from "@chakra-ui/react";
import Select from "react-select";
import ContactModel from "common/components/commonTableModel/ContactModel";
import LeadModel from "common/components/commonTableModel/LeadModel";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";

import { LiaMousePointerSolid } from "react-icons/lia";
import { toast } from "react-toastify";
import { phoneCallSchema } from "common/schema";
import { getApi, postApi } from "common/services/api";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { crmConstant } from "services/Crm/constant";
import { vaultConstant } from "services/Vault/constant";
import { convertUtcToIst } from "services/Crm/utils/calcUtils";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getContactList } from "common/redux/reducers/contactLeadSlice";
import { getLeadList } from "common/redux/reducers/contactLeadSlice";
import SearchSelect from "common/components/autoComplete/AutoCompleteSelect";

const TaskInformation = (props, setAction) => {
  const [isLoading, setIsLoading] = useState(false);
  const [assignmentToData, setAssignmentToData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const location = useLocation();
  const initialValuesPro = location.state?.initialValuesProp || {};
  const view = location.state?.view || "";
  const dealAccountPhoneNumber = location.state?.dealAccountPhoneNumber;
  const [accountModuleId, setAccountModuleId] = useState("");
  const [minutesInput, setMinutesInput] = useState("");
  const [secondsInput, setSecondsInput] = useState("");
  const initialValues = {
    sender: user?._id,
    recipient: initialValuesPro?.leadPhoneNumber
      ? initialValuesPro?.leadPhoneNumber
      : initialValuesPro?.phoneNumber
      ? initialValuesPro?.phoneNumber
      : "",
    callDuration: "",
    callNotes: "",
    startDate: convertUtcToIst(new Date()),
    endDate: "",
    category: initialValuesPro?.category
      ? initialValuesPro?.category
      : view === constant.lead
      ? constant.lead
      : view === constant.accounts
      ? constant.accounts
      : view === constant.deals
      ? constant.deals
      : constant.contact || "Contact",
    subject: "",
    callType: "",
    status: "",
    createByLead:
      view === constant.lead && initialValuesPro?._id
        ? initialValuesPro._id
        : "",
    createBy:
      view === constant.contact && initialValuesPro?._id
        ? initialValuesPro._id
        : "",
    createByAccount:
      view === constant.accounts && initialValuesPro?._id
        ? initialValuesPro._id
        : "",
    createByDeal:
      view === constant.deals && initialValuesPro?._id
        ? initialValuesPro._id
        : "",
  };
  const [relatedContacts, setRelatedContacts] = useState([]);

  useEffect(() => {
    setFieldValue("startDate", convertUtcToIst(new Date()));
  }, []);
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: phoneCallSchema,
    onSubmit: (values, { resetForm }) => {
      AddData(resetForm);
    },
  });
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const AddData = async (resetForm) => {
    try {
      const userInfo = localStorage.getItem("user");

      setIsLoading(true);
      const updatedVaules = {
        callOwner: userInfo ? JSON.parse(userInfo ?? "")._id : "",
        ...values,
      };
      let response = await postApi("api/phoneCall/add", updatedVaules);
      if (response.status === 200) {
        formik.resetForm();
        toast.success(crmConstant.callSuccess);
        navigate(-1);
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
      resetForm();
    }
  };
  const dispatch = useDispatch();
  const contacts = useSelector((state) => state.contactLead.contacts);
  const leadData = useSelector((state) => state.contactLead.leads);

  useEffect(() => {
    if (values.category === "Contact") {
      setContactData(contacts);
      setAssignmentToData(contacts);
    } else if (values.category === "Lead") {
      setAssignmentToData(leadData);
    }
  }, [contacts, leadData]);
  useEffect(() => {
    const fetchData = async () => {
      values.start = props?.date;
      try {
        dispatch(getContactList({ fetchAllData: true }));
        async function fetchModuleIds() {
          const dealRes = await getApi(
            `api/custom-field/?moduleName=${constant.deals}`
          );
          const dealModuleId = dealRes?.data[0]._id;
          console.log(dealModuleId, "dealModuleId");

          const accountRes = await getApi(
            `api/custom-field/?moduleName=${constant.accounts}`
          );
          const accountModuleId = accountRes?.data[0]._id;
          setAccountModuleId(accountModuleId);
          console.log(accountModuleId, "accountModuleId");
        }

        fetchModuleIds();
        if (values.category === "Lead") {
          dispatch(getLeadList({ fetchAllData: true }));
        } else if (["Deals", "Accounts"].includes(values.category)) {
          const res = await getApi(
            `api/custom-field/?moduleName=${values.category}`
          );
          const matchedModule = res?.data?.find(
            (item) => item?.moduleName === values.category
          );

          if (!matchedModule?._id) {
            toast.error(`No module found for ${values.category}`);
            return;
          }

          const dynamicResult = await getApi(
            user.role === "superAdmin"
              ? `api/form?moduleId=${matchedModule._id}&allData=true`
              : `api/form?moduleId=${matchedModule._id}&createBy=${user._id}&allData=true`
          );
          setAssignmentToData(dynamicResult?.data?.data || []);
        }
      } catch (e) {
        console.error(e);
        toast.error("Something went wrong");
      }
    };

    fetchData();
  }, [props?.date, values.category, user._id, user.role]);

  const fetchRecipientData = async () => {
    if (values.createBy) {
      let response = await getApi("api/contact/view/", values.createBy);
      if (response?.status === 200) {
        setFieldValue("recipient", response?.data?.contact?.phoneNumber);
        values.recipient = response?.data?.contact?.phoneNumber;
      }
    } else if (values.createByLead) {
      let response = await getApi("api/lead/view/", values.createByLead);
      if (response?.status === 200) {
        setFieldValue("recipient", response?.data?.lead?.leadPhoneNumber);
        values.recipient = response?.data?.lead?.leadPhoneNumber;
      }
    } else {
      setFieldValue("recipient", "");
    }
  };

  useEffect(() => {
    fetchRecipientData();
  }, [values.createBy, values.createByLead]);
  function onChangHeandler(e) {
    if (e.target.value.startsWith(" ")) {
      return;
    }
    handleChange(e);
  }

  const handleBackPage = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (assignmentToData?.length > 0 && contactData?.length > 0) {
      let selectedValue = null;

      if (values.category === constant.accounts && values.createByAccount) {
        selectedValue = values.createByAccount;
      } else if (values.category === constant.deals && values.createByDeal) {
        selectedValue = values.createByDeal;
      }

      if (selectedValue) {
        const matchedItem = assignmentToData.find(
          (item) => item._id === selectedValue
        );
        if (matchedItem) {
          const contactIds = matchedItem?.contact?.map(String) || [];
          const matchedContacts = contactData
            .filter((c) => contactIds.includes(String(c._id)))
            .map((contact) => ({
              value: contact._id,
              label: contact.contactName || "-",
            }));
          setRelatedContacts(matchedContacts);
        }
      }
    }
  }, [
    assignmentToData,
    contactData,
    values.category,
    values.createByAccount,
    values.createByDeal,
  ]);

  useEffect(() => {
    if (view === constant.accounts) {
      setFieldValue("recipient", initialValuesPro.phoneNumber);
    } else if (view === constant.deals) {
      setFieldValue("recipient", dealAccountPhoneNumber);
    }
  }, []);

  useEffect(() => {
    const total = Number(values.callDuration || 0);
    const mins = Math.floor(total / 60);
    const secs = total % 60;
    setMinutesInput(mins > 0 ? String(mins) : "");
    setSecondsInput(secs > 0 ? String(secs) : "");
  }, [values.callDuration]);

  const handleTextareaChange = (e, fieldName, setFieldValue) => {
    const input = e.target.value;
    const limitedText = input.slice(0, 1000);
    setFieldValue(fieldName, limitedText);
  };

  const handleDurationChange = (minsStr, secsStr) => {
    const mins = parseInt(minsStr) || 0;
    const secs = parseInt(secsStr) || 0;
    const totalSeconds = mins * 60 + secs;
    handleChange({
      target: { name: "callDuration", value: String(totalSeconds) },
    });
  };

  return (
    <>
      <Box className="commonPanelBody">
        <ContactModel
          isOpen={contactModelOpen}
          data={assignmentToData}
          onClose={setContactModel}
          fieldName="createBy"
          setFieldValue={setFieldValue}
        />
        {/* Lead Model  */}
        <LeadModel
          isOpen={leadModelOpen}
          data={assignmentToData}
          onClose={setLeadModel}
          fieldName="createByLead"
          setFieldValue={setFieldValue}
        />

        <Grid templateColumns="repeat(12, 1fr)" gap={3}>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.callSubject} <Text color={"red.600"}>*</Text>
            </FormLabel>
            <Input
              fontSize="sm"
              onChange={(e) => {
                onChangHeandler(e);
              }}
              onBlur={handleBlur}
              value={values.subject}
              name="subject"
              placeholder={crmConstant.enterSubject}
              fontWeight="500"
              borderColor={
                errors?.subject && touched?.subject ? "red.300" : null
              }
            />
            <Text fontSize="sm" mb="10px" color={"red.600"}>
              {" "}
              {errors.subject && touched.subject && errors.subject}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.callType} <Text color={"red.600"}>*</Text>
            </FormLabel>
            <ChakraSelect
              onChange={(e) => {
                setFieldValue("callType", e.target.value);
              }}
              placeholder={crmConstant.select}
              value={values.callType}
            >
              <option value="Inbound">{crmConstant.inBound}</option>
              <option value="Outbound">{crmConstant.outBound}</option>
            </ChakraSelect>
            <Text mb="10px" fontSize="sm" color={"red.600"}>
              {errors.callType && touched.callType && errors.callType}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.dateAndTime}
              <Text color={"red.600"}>*</Text>
            </FormLabel>
            <Input
              type="datetime-local"
              fontSize="sm"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.startDate}
              name="startDate"
              fontWeight="500"
              placeholder="DD/MM/YY"
              borderColor={
                errors?.startDate && touched?.startDate ? "red.300" : null
              }
            />
            <Text mb="10px" fontSize="sm" color={"red"}>
              {" "}
              {errors.startDate && touched.startDate && errors.startDate}
            </Text>
          </GridItem>
          {/* <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.callDuration}
              <Text color={"red.600"}>*</Text>
            </FormLabel>
            <InputGroup>
              <Input
                fontSize="sm"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^\d]/g, "");
                  handleChange({ target: { name: e.target.name, value } });
                }}
                onBlur={handleBlur}
                value={values.callDuration}
                name="callDuration"
                placeholder={crmConstant.callDuration}
                fontWeight="500"
                borderColor={
                  errors.callDuration && touched.callDuration ? "red.300" : null
                }
              />
              <InputRightElement right={"20px"}>
                <Text fontSize="sm" color="gray.500">
                  {crmConstant.minutes}
                </Text>
              </InputRightElement>
            </InputGroup>
            <Text mb="10px" fontSize="sm" color={"red.600"}>
              {" "}
              {errors.callDuration &&
                touched.callDuration &&
                errors.callDuration}
            </Text>
          </GridItem> */}

          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.callDuration}
              <Text color="red.600">*</Text>
            </FormLabel>

            <InputGroup gap={2} display="flex">
              <Box flex="1">
                <Input
                  fontSize="sm"
                  type="number"
                  placeholder="Minutes"
                  value={minutesInput}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^\d]/g, "");
                    setMinutesInput(value);
                  }}
                  onBlur={() =>
                    handleDurationChange(minutesInput, secondsInput)
                  }
                />
                <Text mt={1} fontSize="xs" color="gray.500">
                  Minutes
                </Text>
              </Box>

              <Box flex="1">
                <Input
                  fontSize="sm"
                  type="number"
                  placeholder="Seconds"
                  value={secondsInput}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^\d]/g, "");
                    setSecondsInput(value);
                  }}
                  onBlur={() =>
                    handleDurationChange(minutesInput, secondsInput)
                  }
                />
                <Text mt={1} fontSize="xs" color="gray.500">
                  Seconds
                </Text>
              </Box>
            </InputGroup>

            {errors.callDuration && touched.callDuration && (
              <Text mb="10px" fontSize="sm" color="red.600">
                {errors.callDuration}
              </Text>
            )}
          </GridItem>
          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.related}
            </FormLabel>
            <ChakraSelect
              onChange={(e) => {
                setFieldValue("category", e.target.value);
                setFieldValue("createBy", "");
                setFieldValue("createByLead", "");
                setRelatedContacts([]);
                setFieldValue("recipient", "");
                setFieldValue("createByDeal", "");
                setFieldValue("createByAccount", "");
              }}
              placeholder={crmConstant.select}
              value={values.category}
            >
              <option value="Contact">{crmConstant.contact}</option>
              <option value="Lead">{crmConstant.lead}</option>
              <option value="Accounts">{constant.account}</option>
              <option value="Deals">{constant.deal}</option>
            </ChakraSelect>
            <Text mb="10px" fontSize="sm" color={"red.600"}>
              {errors.category && touched.category && errors.category}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 12, md: 6 }}>
            {values.category === "Contact" ? (
              <GridItem
                colSpan={{ base: 12, md: 6 }}
                className="selectDropBtnNoBorder"
              >
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.participant} ({crmConstant.contact})
                </FormLabel>
                {/* <ChakraSelect
                  value={values.createBy || ""}
                  name="createBy"
                  onChange={handleChange}
                  mb={errors.createBy && touched.createBy ? undefined : "10px"}
                  fontWeight="500"
                  placeholder={crmConstant.selectParticipant}
                  borderColor={
                    errors.createBy && touched.createBy ? "red.300" : null
                  }
                >
                  {assignmentToData?.length &&
                    assignmentToData?.map((item) => (
                      <option value={item._id} key={item._id}>
                        {item?.contactName ?? "-"}
                      </option>
                    ))}
                </ChakraSelect> */}
                <SearchSelect
                  name="createBy"
                  value={values.createBy || ""}
                  placeholder={crmConstant.selectParticipant}
                  onChange={(option) => {
                    handleChange({
                      target: {
                        name: "createBy",
                        value: option?.value || "",
                      },
                    });
                  }}
                  options={assignmentToData?.map((item) => ({
                    label: item?.contactName ?? "-",
                    value: item._id,
                  }))}
                  wrapperStyle={{
                    marginBottom:
                      errors.createBy && touched.createBy ? undefined : "10px",
                    border:
                      errors.createBy && touched.createBy
                        ? "1px solid #FC8181"
                        : "1px solid var(--chakra-colors-chakra-border-color)",
                    borderRadius: "0.375rem",
                  }}
                  fontWeight="500"
                  className="custom-select"
                />
                <Text mb="10px" fontSize="sm" color={"red.600"}>
                  {errors.createBy && touched.createBy && errors.createBy}
                </Text>
              </GridItem>
            ) : values.category === "Lead" ? (
              <GridItem
                colSpan={{ base: 12, md: 6 }}
                className="selectDropBtnNoBorder"
              >
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.participant} ({crmConstant.lead})
                </FormLabel>
                {/* <ChakraSelect
                  value={values.createByLead}
                  name="createByLead"
                  onChange={handleChange}
                  mb={
                    errors.createByLead && touched.createByLead
                      ? undefined
                      : "10px"
                  }
                  fontWeight="500"
                  placeholder={crmConstant.selectParticipant}
                  borderColor={
                    errors.createByLead && touched.createByLead
                      ? "red.300"
                      : null
                  }
                >
                  {assignmentToData?.map((item) => (
                    <option value={item._id} key={item._id}>
                      {item.leadName ??
                        `${item.firstName} ${item.lastName}` ??
                        "-"}
                    </option>
                  ))}
                </ChakraSelect> */}
                <SearchSelect
                  name="createByLead"
                  value={values.createByLead}
                  placeholder={crmConstant.selectParticipant}
                  onChange={(option) => {
                    handleChange({
                      target: {
                        name: "createByLead",
                        value: option?.value || "",
                      },
                    });
                  }}
                  options={assignmentToData?.map((item) => ({
                    label:
                      item.leadName ||
                      `${item.firstName} ${item.lastName}` ||
                      "-",
                    value: item._id,
                  }))}
                  wrapperStyle={{
                    marginBottom:
                      errors.createByLead && touched.createByLead
                        ? undefined
                        : "10px",
                    border:
                      errors.createByLead && touched.createByLead
                        ? "1px solid #FC8181"
                        : "1px solid var(--chakra-colors-chakra-border-color)",
                    borderRadius: "0.375rem",
                  }}
                  className="custom-select"
                  isSearchable
                />
                <Text mb="10px" fontSize="sm" color={"red.600"}>
                  {errors.createByLead &&
                    touched.createByLead &&
                    errors.createByLead}
                </Text>
              </GridItem>
            ) : values.category === "Accounts" ||
              values.category === "Deals" ? (
              <GridItem
                colSpan={{ base: 12, md: 6 }}
                className="selectDropBtnNoBorder"
              >
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.participant} (
                  {values.category === "Accounts"
                    ? constant.accounts
                    : constant.deals}
                  )
                </FormLabel>
                {/* <ChakraSelect
                  value={
                    values.category === constant.accounts
                      ? values.createByAccount
                      : values.createByDeal
                  }
                  name={
                    values.category === constant.accounts
                      ? "createByAccount"
                      : "createByDeal"
                  }
                  placeholder={crmConstant.selectParticipant}
                  // onChange={(e) => {
                  onChange={async (e) => {
                    const selectedValue = e.target.value;

                    console.log("selectedValue", selectedValue);
                    const currentCategory = values.category;

                    // if (values.category === constant.accounts) {
                    //   setFieldValue("createByAccount", selectedValue);
                    //   console.log("createByAccount", selectedValue);
                    // } else {
                    //   setFieldValue("createByDeal", selectedValue);
                    // }

                    if (currentCategory === constant.accounts) {
                      setFieldValue("createByAccount", selectedValue);
                    } else {
                      setFieldValue("createByDeal", selectedValue);
                    }

                    const matchedItem = assignmentToData.find(
                      (item) => item._id === selectedValue
                    );
                    const contactIds = matchedItem?.contact?.map(String) || [];
                    const matchedContacts = contactData
                      .filter((c) => contactIds.includes(String(c._id)))
                      .map((contact) => ({
                        value: contact._id,
                        label: contact.contactName || "-",
                      }));
                    setRelatedContacts(matchedContacts);
                    // setFieldValue("recipient", initialValuesPro?.phoneNumber || "");

                    if (
                      selectedValue &&
                      // (view === constant.accounts || values.category === constant.accounts)
                      values.category === constant.accounts
                    ) {
                      try {
                        const res = await getApi(
                          `api/custom-field/?moduleName=${values.category}`
                        );
                        const matchedModule = res?.data?.find(
                          (item) => item?.moduleName === values.category
                        );

                        if (!matchedModule?._id) {
                          toast.error(`No module found for ${values.category}`);
                          return;
                        }

                        const resModuleId = await getApi(
                          user.role === "superAdmin"
                            ? `api/form?moduleId=${matchedModule._id}`
                            : `api/form?moduleId=${matchedModule._id}&createBy=${user._id}`
                        );

                        const moduleData = resModuleId?.data?.data || [];
                        const matchedModuleItem = moduleData.find(
                          (item) => item._id === selectedValue
                        );

                        const phoneNumber =
                          matchedModuleItem?.phoneNumber || "";
                        setFieldValue("recipient", phoneNumber);
                      } catch (err) {
                        console.error(
                          "Error fetching module phone number:",
                          err
                        );
                        setFieldValue("recipient", "");
                      }
                    }

                    //  else if (selectedValue && ( values.category === constant.deals)) {
                    else if (
                      selectedValue &&
                      (view === constant.deals ||
                        values.category === constant.deals)
                    ) {
                      try {
                        const res = await getApi(
                          `api/custom-field/?moduleName=${values.category}`
                        );
                        const matchedModule = res?.data?.find(
                          (item) => item?.moduleName === values.category
                        );

                        if (!matchedModule?._id) {
                          toast.error(`No module found for ${values.category}`);
                          return;
                        }

                        const resModuleId = await getApi(
                          user.role === "superAdmin"
                            ? `api/form?moduleId=${matchedModule._id}`
                            : `api/form?moduleId=${matchedModule._id}&createBy=${user._id}`
                        );

                        const moduleData = resModuleId?.data?.data || [];

                        // Step 1: find the selected deal
                        const selectedDeal = moduleData.find(
                          (item) => item._id === selectedValue
                        );
                        console.log("selectedDeal", selectedDeal);
                        if (!selectedDeal?.account) {
                          toast.error("No account associated with this deal");
                          setFieldValue("recipient", "");
                          return;
                        }

                        // Step 2: fetch account data by account ID
                        const accountRes = await getApi(
                          `api/form/view/${selectedDeal.account}?moduleId=${accountModuleId}`
                        );
                        console.log(
                          "accountRes",
                          accountRes.data.data.phoneNumber
                        );
                        const phoneNumber =
                          accountRes.data.data.phoneNumber || "";

                        // Step 3: set recipient value
                        setFieldValue("recipient", phoneNumber);
                      } catch (err) {
                        console.error(
                          "Error fetching deal/account phone number:",
                          err
                        );
                        setFieldValue("recipient", "");
                      }
                    } else {
                      setFieldValue("recipient", "");
                    }
                  }}
                  fontWeight="500"
                  borderColor={
                    (values.category === constant.accounts &&
                      errors.createByAccount &&
                      touched.createByAccount) ||
                      (values.category === constant.deals &&
                        errors.createByDeal &&
                        touched.createByDeal)
                      ? "red.300"
                      : null
                  }
                >
                  {assignmentToData?.map((item) => (
                    <option value={item._id} key={item._id}>
                      {item.label || item.dealName || item.accountName || "-"}
                    </option>
                  ))}
                </ChakraSelect> */}
                <SearchSelect
                  name={
                    values.category === constant.accounts
                      ? "createByAccount"
                      : "createByDeal"
                  }
                  value={
                    values.category === constant.accounts
                      ? values.createByAccount
                      : values.createByDeal
                  }
                  placeholder={crmConstant.selectParticipant}
                  fontWeight="500"
                  options={assignmentToData?.map((item) => ({
                    label:
                      item.label || item.dealName || item.accountName || "-",
                    value: item._id,
                  }))}
                  onChange={async (option) => {
                    const selectedValue = option?.value || "";
                    const currentCategory = values.category;

                    if (currentCategory === constant.accounts) {
                      setFieldValue("createByAccount", selectedValue);
                    } else {
                      setFieldValue("createByDeal", selectedValue);
                    }

                    const matchedItem = assignmentToData.find(
                      (item) => item._id === selectedValue
                    );
                    const contactIds = matchedItem?.contact?.map(String) || [];
                    const matchedContacts = contactData
                      .filter((c) => contactIds.includes(String(c._id)))
                      .map((contact) => ({
                        value: contact._id,
                        label: contact.contactName || "-",
                      }));
                    setRelatedContacts(matchedContacts);

                    if (
                      selectedValue &&
                      values.category === constant.accounts
                    ) {
                      try {
                        const res = await getApi(
                          `api/custom-field/?moduleName=${values.category}`
                        );
                        const matchedModule = res?.data?.find(
                          (item) => item?.moduleName === values.category
                        );

                        if (!matchedModule?._id) {
                          toast.error(`No module found for ${values.category}`);
                          return;
                        }

                        const resModuleId = await getApi(
                          user.role === "superAdmin"
                            ? `api/form?moduleId=${matchedModule._id}`
                            : `api/form?moduleId=${matchedModule._id}&createBy=${user._id}`
                        );

                        const moduleData = resModuleId?.data?.data || [];
                        const matchedModuleItem = moduleData.find(
                          (item) => item._id === selectedValue
                        );

                        const phoneNumber =
                          matchedModuleItem?.phoneNumber || "";
                        setFieldValue("recipient", phoneNumber);
                      } catch (err) {
                        console.error(
                          "Error fetching module phone number:",
                          err
                        );
                        setFieldValue("recipient", "");
                      }
                    } else if (
                      selectedValue &&
                      (view === constant.deals ||
                        values.category === constant.deals)
                    ) {
                      try {
                        const res = await getApi(
                          `api/custom-field/?moduleName=${values.category}`
                        );
                        const matchedModule = res?.data?.find(
                          (item) => item?.moduleName === values.category
                        );

                        if (!matchedModule?._id) {
                          toast.error(`No module found for ${values.category}`);
                          return;
                        }

                        const resModuleId = await getApi(
                          user.role === "superAdmin"
                            ? `api/form?moduleId=${matchedModule._id}`
                            : `api/form?moduleId=${matchedModule._id}&createBy=${user._id}`
                        );

                        const moduleData = resModuleId?.data?.data || [];
                        const selectedDeal = moduleData.find(
                          (item) => item._id === selectedValue
                        );

                        if (!selectedDeal?.account) {
                          toast.error("No account associated with this deal");
                          setFieldValue("recipient", "");
                          return;
                        }

                        const accountRes = await getApi(
                          `api/form/view/${selectedDeal.account}?moduleId=${accountModuleId}`
                        );

                        const phoneNumber =
                          accountRes?.data?.data?.phoneNumber || "";
                        setFieldValue("recipient", phoneNumber);
                      } catch (err) {
                        console.error(
                          "Error fetching deal/account phone number:",
                          err
                        );
                        setFieldValue("recipient", "");
                      }
                    } else {
                      setFieldValue("recipient", "");
                    }
                  }}
                  wrapperStyle={{
                    border:
                      (values.category === constant.accounts &&
                        errors.createByAccount &&
                        touched.createByAccount) ||
                      (values.category === constant.deals &&
                        errors.createByDeal &&
                        touched.createByDeal)
                        ? "1px solid #FC8181" // red.300
                        : "1px solid var(--chakra-colors-chakra-border-color)",
                    borderRadius: "0.375rem",
                  }}
                />

                <Text mb="10px" color="red" fontSize="sm">
                  {(values.category === constant.accounts &&
                    errors.createByAccount &&
                    touched.createByAccount &&
                    errors.createByAccount) ||
                    (values.category === constant.deals &&
                      errors.createByDeal &&
                      touched.createByDeal &&
                      errors.createByDeal)}
                </Text>
              </GridItem>
            ) : null}

            {relatedContacts.length > 0 && (
              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel fontSize="sm" fontWeight="500" mb="8px">
                  {constant.selectContacts} {values.category}
                </FormLabel>

                {/* <Select
                  placeholder="Select related contacts"
                  name="createBy"
                  options={relatedContacts}
                  onChange={async (selected) => {
                    const selectedValue = selected?.value || "";
                    setFieldValue("createBy", selectedValue);

                    if (selectedValue) {
                      try {
                        const res = await getApi(
                          "api/contact/view/",
                          selectedValue
                        );
                        const phoneNumber =
                          res?.status === 200
                            ? res.data?.contact?.phoneNumber
                            : "";
                        setFieldValue("recipient", phoneNumber || "");
                      } catch (err) {
                        console.error(
                          "Error fetching contact phone number:",
                          err
                        );
                        setFieldValue("recipient", "");
                      }
                    } else {
                      setFieldValue("recipient", "");
                    }
                  }}
                  value={
                    relatedContacts.find(
                      (item) => item.value === values.createBy
                    ) || null
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                /> */}

                <SearchSelect
                  name="createBy"
                  placeholder="Select related contacts"
                  options={relatedContacts}
                  value={
                    relatedContacts.find(
                      (item) => item.value === values.createBy
                    ) || null
                  }
                  onChange={async (selectedOption) => {
                    const selectedValue = selectedOption?.value || "";
                    setFieldValue("createBy", selectedValue);

                    if (selectedValue) {
                      try {
                        const res = await getApi(
                          "api/contact/view/",
                          selectedValue
                        );
                        const phoneNumber =
                          res?.status === 200
                            ? res.data?.contact?.phoneNumber
                            : "";
                        setFieldValue("recipient", phoneNumber || "");
                      } catch (err) {
                        console.error(
                          "Error fetching contact phone number:",
                          err
                        );
                        setFieldValue("recipient", "");
                      }
                    } else {
                      setFieldValue("recipient", "");
                    }
                  }}
                  isSearchable
                  wrapperStyle={{
                    border:
                      errors.createBy && touched.createBy
                        ? "1px solid #FC8181" // Chakra red.300
                        : "1px solid var(--chakra-colors-chakra-border-color)",
                    borderRadius: "0.375rem",
                  }}
                />

                <Text mb="10px" color="red" fontSize="sm">
                  {errors.createBy && touched.createBy && errors.createBy}
                </Text>
              </GridItem>
            )}
          </GridItem>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.contactNo}
              <Text color={"red.600"}>*</Text>
            </FormLabel>
            <Input
              fontSize="sm"
              disabled
              value={values.recipient ? values.recipient : ""}
              name="recipient"
              placeholder={crmConstant.contactNo}
              fontWeight="500"
              borderColor={
                errors.recipient && touched.recipient ? "red.300" : null
              }
            />
          </GridItem>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.status} <Text color={"red.600"}>*</Text>
            </FormLabel>
            <ChakraSelect
              onChange={(e) => {
                setFieldValue("status", e.target.value);
              }}
              placeholder={crmConstant.select}
              value={values.status}
            >
              <option value="Scheduled">{crmConstant.scheduled}</option>
              <option value="Completed">{crmConstant.completed}</option>
            </ChakraSelect>
            <Text mb="10px" fontSize="sm" color={"red.600"}>
              {errors.status && touched.status && errors.status}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 12 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.description}
            </FormLabel>
            <Textarea
              resize={"none"}
              fontSize="sm"
              placeholder={crmConstant.description}
              onChange={(e) =>
                handleTextareaChange(e, "callNotes", setFieldValue)
              }
              onBlur={handleBlur}
              value={values.callNotes}
              name="callNotes"
              fontWeight="500"
              borderColor={
                errors.callNotes && touched.callNotes ? "red.300" : null
              }
            />
            <Text
              mt={1}
              fontSize="xs"
              textAlign="right"
              color={
                (values.callNotes?.length || 0) === 1000 ? "red.500" : "gray.500"
              }
            >
              {0 + (values.callNotes?.length || 0)}/1000
            </Text>
            <Text mb="10px" fontSize="sm" color={"red.600"}>
              {" "}
              {errors.callNotes && touched.callNotes && errors.callNotes}
            </Text>
          </GridItem>
        </Grid>
      </Box>
      <Box className="createJobOpening-tabsPanelFooter">
        <Button
          size="sm"
          sx={{
            marginRight: 1,
            textTransform: "capitalize",
          }}
          variant="outline"
          onClick={handleBackPage}
          className="cancelBtn theme-btn2"
        >
          {crmConstant.back}
        </Button>
        <Button
          variant="brand"
          className="theme-btn1"
          size="sm"
          disabled={isLoading ? true : false}
          onClick={handleSubmit}
        >
          {isLoading ? (
            <Spinner
              size={20}
              paddingRight={5}
              border={`3px solid ${globalStyles.colors.loaderBorder}`}
              borderTop={`1px solid ${globalStyles.colors.transparent}`}
            />
          ) : (
            ""
          )}{" "}
          {constant.save}
        </Button>
      </Box>
    </>
  );
};

const CreateCallLogs = () => {
  const [formData, setFormData] = useState({
    title: "",
    details: "",
    description: "",
  });
  const navigate = useNavigate();

  const handleBackPage = () => {
    navigate(-1);
  };

  const tabsData = [
    { label: crmConstant.callInformation, Icon: JobOpeningIcon },
  ];

  const panelsData = [<TaskInformation formData={formData} />];

  return (
    <CreateTabs
      tabsData={tabsData}
      panelsData={panelsData}
      handleBackPage={handleBackPage}
      pageTitle={crmConstant.createCallLog}
    />
  );
};

export default CreateCallLogs;
